import { Cookies } from "react-cookie";
import cookiesKeys from "Common/cookies/cookiesKeys";
import isObject from "lodash/isObject";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import trim from "lodash/trim";
function isAuthToken(token) {
    return (isObject(token) &&
        token !== null &&
        "Id" in token &&
        isNumber(token.Id) &&
        Number.isInteger(token.Id) &&
        token.Id > 0 &&
        "Permissions" in token &&
        isNumber(token.Permissions) &&
        Number.isInteger(token.Permissions) &&
        token.Permissions >= 0 &&
        "Login" in token &&
        isString(token.Login) &&
        trim(token.Login).length > 0);
}
const getCookieClientAuth = () => {
    const cookies = new Cookies();
    const cookie = cookies.get(cookiesKeys.clientAuth);
    const token = cookie ? JSON.parse(decodeURIComponent(cookie)) : undefined;
    return isAuthToken(token) ? token : undefined;
};
export default getCookieClientAuth;
